import React from "react";
import { cn } from "../../../utils/cn";
import { LEGEND_SWATCH } from "../scheduleGridTheme";

const LEGEND_ITEMS = [
  { key: "scheduled", label: "Agendada" },
  { key: "video", label: "Vídeo" },
  { key: "completed", label: "Realizada" },
  { key: "noshow", label: "Não apareceu" },
  { key: "blocked", label: "Bloqueado" },
  { key: "free", label: "Livre" },
] as const;

type ScheduleGridLegendProps = {
  placement?: "top" | "bottom";
};

const ScheduleGridLegend: React.FC<ScheduleGridLegendProps> = ({
  placement = "bottom",
}) => (
  <div
    className={cn(
      "flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-3 py-4",
      placement === "top" ? "bg-[#F7FAFC]" : "mt-2 border-t border-[#EDF2F7] pt-2"
    )}
  >
    <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5">
      {LEGEND_ITEMS.map((item) => (
        <span
          key={item.key}
          className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#4A5568]"
        >
          <span
            className={`h-3.5 w-3.5 shrink-0 rounded-sm ${LEGEND_SWATCH[item.key]}`}
            aria-hidden
          />
          {item.label}
        </span>
      ))}
    </div>
  </div>
);

export default ScheduleGridLegend;
